<script lang="ts">
  import TreeView from "./TreeView.svelte"

  import { conceptDatasStore } from "../stores/conceptDatasStore"
  import { exerciseDatasArray } from "../stores/exerciseDatasStore"
  import { ExerciseData } from "../dataTypes/exerciseData"
  import type { ITreeViewNode } from "./TreeView/iTreeViewNode"
  let conceptTreeViewNodes:Array<ITreeViewNode> = new Array<ITreeViewNode>()

  export let exerciseData:ExerciseData
  $: generateConceptTreeViewNodes(exerciseData)

  function generateConceptTreeViewNodes(exerciseData:ExerciseData):void {
    //console.log("exerciseData.index: " + exerciseData.index)
    for (let exerciseIndex = exerciseData.index; exerciseIndex >= 0; exerciseIndex--) {
      for (let conceptIndex = exerciseDatasArray[exerciseIndex].concepts.length - 1; conceptIndex >= 0; conceptIndex--) {
        let conceptID = exerciseDatasArray[exerciseIndex].concepts[conceptIndex]
        //console.log("conceptID: " + conceptID)
        conceptTreeViewNodes.push($conceptDatasStore.get(conceptID).getTreeViewNode())
      }
    }
    conceptTreeViewNodes = conceptTreeViewNodes
    //console.log("conceptTreeViewNodes: " + JSON.stringify(conceptTreeViewNodes))
  }
</script>

{#if conceptTreeViewNodes.length > 0}
<div class="bg-darkBackHigh text-darkForeHigh text-lg px-3 my-3">Concepts</div>
<TreeView class="text-darkFore ml-3" label={null} text={null} children={conceptTreeViewNodes}></TreeView>
{/if}